module.exports = __webpack_public_path__ + "img/x-red.32724d98.svg";